import { render, staticRenderFns } from "./ChefPricing.vue?vue&type=template&id=75a4031a&"
import script from "./ChefPricing.vue?vue&type=script&lang=js&"
export * from "./ChefPricing.vue?vue&type=script&lang=js&"
import style0 from "./ChefPricing.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../fodchef/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports